import { render } from "./RADashboard.vue?vue&type=template&id=2499373b"
import script from "./RADashboard.vue?vue&type=script&lang=js"
export * from "./RADashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__